import { render } from "./CreateUsers.vue?vue&type=template&id=243dc7de&scoped=true"
import script from "./CreateUsers.vue?vue&type=script&lang=js"
export * from "./CreateUsers.vue?vue&type=script&lang=js"

import "./CreateUsers.vue?vue&type=style&index=0&id=243dc7de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243dc7de"]])

export default __exports__